import { credentialName } from "@/lib/credentials";
// بطاقات تجربة الموظف: برنامج (محطات وتقدم وإجراء) + شهادة/مؤهل من الدليل — بلا مستويات
import { useState } from "react";
import { CertForm } from "@/masar/pages/Certificates";
import { levelAccent } from "@/masar/colors";
import { HadafBadge } from "@/masar/components/HadafBadge";
import { useNavigate } from "react-router-dom";
import { fileUrl } from "@/v2/lib/files";
import { GlassCard, Chip, Bar } from "@/v2/components/ui";
import { KIND_AR, PROGRAM_STATE_TONE, fmtDate } from "@/masar/lib";
import { PlayCircle, CheckCircle2, Hourglass, Award, GraduationCap, BadgeCheck, Heart, HeartOff, Lock, Circle, Star } from "lucide-react";

export function ProgramCard({ p, compact = false }) {
  const navigate = useNavigate();
  const [claim, setClaim] = useState(false);
  const go = () => p.challenge_id ? navigate(`/journey/${p.challenge_id}`) : navigate("/journey");
  return (
    <><GlassCard hover style={levelAccent(p.level)} className={`p-4 flex flex-col gap-3 ${p.status === "completed" ? "border-ok/30" : ""}`} data-testid="program-card">
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-start gap-2.5 min-w-0">
          <span className={`shrink-0 mt-1 ${p.status === "completed" ? "text-ok" : "text-beige-ink"}`} aria-hidden="true">
            {p.status === "completed" ? <CheckCircle2 size={18} /> : p.status === "unavailable" ? <Hourglass size={18} /> : <PlayCircle size={18} />}
          </span>
          <div className="min-w-0">
            <h3 className="m-0 !text-[1.15rem] leading-snug" data-testid="program-name">{p.name}</h3>
            <div className="text-xs text-ink-2">{p.duration || (p.hours ? `${p.hours} ساعة` : "")}</div>
          </div>
        </div>
        <Chip tone={PROGRAM_STATE_TONE[p.status]}>{p.status_ar}</Chip>
      </div>
      {!compact && p.desc && <p className="text-xs text-ink-2 line-clamp-1">{p.desc}</p>}
      {p.status !== "unavailable" && p.stations_total > 0 && (
        <div>
          <div className="flex items-center justify-between text-xs text-ink-2 mb-1"><span>أكملت {p.stations_done} من {p.stations_total} محطات</span><span dir="ltr">{p.progress_pct}%</span></div>
          <Bar value={p.progress_pct} className="!h-2" />
        </div>
      )}
      <div className="mt-auto flex items-center justify-between gap-2 flex-wrap pt-1">
        {p.status === "unavailable" && <span className="text-xs text-ink-2">سيُتاح عند نشر محتواه</span>}
        {p.action === "start" && <button onClick={go} className="v2-btn v2-btn-sm" data-testid={`program-start-${p.program_id}`}><PlayCircle size={13} /> ابدأ في تميز</button>}
        {p.action === "continue" && <button onClick={go} className="v2-btn v2-btn-sm" data-testid={`program-continue-${p.program_id}`}><PlayCircle size={13} /> تابع في تميز</button>}
        {p.action === "certificate" && <a href={fileUrl(`/api/masar/completions/${p.completion?.challenge_id || p.challenge_id}.pdf`)} target="_blank" rel="noreferrer" className="v2-btn v2-btn-sm" data-testid={`program-cert-${p.program_id}`}><Award size={13} /> عرض شهادتك</a>}
        {p.action === "record" && <button onClick={() => navigate("/masar/certificates")} className="v2-btn v2-btn-sm">عرض الشهادة المعتمدة</button>}
        {p.locked && p.status !== "completed" && <span className="text-xs text-ink-2">أكمل البرامج السابقة أولًا</span>}
        {p.category === "general" && p.can_claim && p.status !== "completed" && <button className="v2-btn-ghost v2-btn-sm" onClick={() => setClaim(true)}>لدي هذه الدورة</button>}
        {p.status === "unavailable" && <Chip tone="muted"><Lock size={11} /> قريبًا</Chip>}
      </div>
    </GlassCard>
    {claim && <CertForm initial={{ program_id: p.program_id, kind: "course", name: p.name }} onClose={() => setClaim(false)} />}</>
  );
}

export function GuideCard({ x, onOpen, onInterest, compact = false }) {
  const academic = x.kind === "academic";
  return (
    <GlassCard hover className="p-4 flex flex-col gap-2" data-testid="guide-card">
      <div className="flex items-start justify-between gap-2">
        <div className="text-sm text-ink-3 flex items-center gap-1.5">{academic ? <GraduationCap size={15} className="text-beige-ink" /> : <BadgeCheck size={15} className="text-beige-ink" />}{KIND_AR[x.kind] || KIND_AR.professional}</div>
        <div className="flex flex-wrap gap-1 justify-end">
          {x.my_status && <Chip tone={x.my_status === "approved" ? "emerald" : "gold"}>{x.my_status === "approved" ? "لديك شهادة معتمدة" : x.my_status_ar}</Chip>}
        </div>
      </div>
      <div><h3 className="m-0 !text-[1.2rem] leading-snug">{credentialName(x)}</h3>{x.issuer && <div className="text-sm text-ink-2">{x.issuer}</div>}</div>
      {!compact && x.desc && <p className="text-xs text-ink-2 line-clamp-2">{x.desc}</p>}
      <div className="mt-auto flex items-center justify-between gap-2 pt-1 flex-wrap">
        <div className="flex gap-1.5">
          <button onClick={() => onOpen(x)} className="v2-btn v2-btn-sm" data-testid={`guide-open-${x.id}`}>التفاصيل</button>
        </div>
        <HadafBadge support={x.hrdf} />
      </div>
    </GlassCard>
  );
}
